import { denormalize } from "normalizr";
import { connectedDebtor } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.connectedDebtors.ids;

    const denormalized = denormalize(
      { items },
      { items: [connectedDebtor] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
